<template>
  <div>
    <el-card header="Auth Profile">
      <el-form label-width="100px" :model="authUser" class="form">
        <el-form-item label="UID">
          <el-input v-model="authUser.uid" readonly></el-input>
        </el-form-item>
        <el-form-item label="Email">
          <el-input v-model="authUser.email" readonly></el-input>
        </el-form-item>
        <el-form-item label="Display Name">
          <el-input v-model="authUser.displayName" readonly></el-input>
        </el-form-item>
      </el-form>
    </el-card>
    <br>
    <el-card header="Database Profile">
      <el-form label-width="100px" :model="dbUser" class="form">
        <el-form-item label="UID">
          <el-input v-model="dbUser.uid" readonly></el-input>
        </el-form-item>
        <el-form-item label="Email">
          <el-input v-model="dbUser.email" readonly></el-input>
        </el-form-item>
        <el-form-item label="Display Name">
          <el-input v-model="dbUser.name" readonly></el-input>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { auth, db } from '../api.js'

export default {
  name: 'profile',
  data() {
    return {
      labelPosition: 'right',
      authUser: {},
      dbUser: {}
    }
  },
  mounted() {
    this.authUser = auth.currentUser
    const ref = db.ref('/users').child(auth.currentUser.uid)
    this.$bindAsObject('dbUser', ref)
  },
}
</script>

<style lang="stylus" scoped>

.form
  width 480px

</style>



// WEBPACK FOOTER //
// Profile.vue?3b716a22